import React, { useContext, useMemo } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Button } from '@/components/atoms/button'
import { AccountContext } from '@/contexts/account'
import { findFirstAllowedStaffPath, getStoredHotelPmsPermissionSnapshot } from '@/libs/hotel-pms-permission'
import { signout } from '@/apis/auth0'

export const PermissionDenied: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { permissions } = useContext<any>(AccountContext)
  const fallbackPath = useMemo(() => {
    const contextPath = findFirstAllowedStaffPath(permissions)
    if (contextPath) return contextPath

    const storedPermissions = getStoredHotelPmsPermissionSnapshot()?.permissions
    const storedPath = findFirstAllowedStaffPath(storedPermissions)
    if (storedPath) return storedPath

    return undefined
  }, [permissions])

  return (
    <div css={wrapperStyle}>
      <div css={cardStyle}>
        <h2 css={titleStyle}>{t('HotelPms.Error.screenDenied')}</h2>
        <p css={messageStyle}>{t('Please contact support if this issue persists.')}</p>
        <div css={actionsStyle}>
          {fallbackPath && (
            <Button width={140} height={36} buttonType={1} onClick={() => history.replace(fallbackPath)}>
              {t('Back')}
            </Button>
          )}
          <Button width={140} height={36} buttonType={fallbackPath ? 2 : 1} onClick={() => signout()}>
            {t('Logout')}
          </Button>
        </div>
      </div>
    </div>
  )
}

const wrapperStyle = css({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f7f7f7',
  padding: 24,
})

const cardStyle = css({
  backgroundColor: '#fff',
  border: '1px solid #e5e5e5',
  borderRadius: 8,
  padding: 24,
  width: '100%',
  maxWidth: 520,
  textAlign: 'center',
})

const titleStyle = css({
  fontSize: 20,
  margin: '0 0 12px',
  color: '#272727',
})

const messageStyle = css({
  fontSize: 14,
  color: '#676767',
  margin: '0 0 24px',
})

const actionsStyle = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
  justifyContent: 'center',
  alignItems: 'center',
})
